module.exports = __webpack_public_path__ + "static/media/products.aee157b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/products.svg
// module id = 2094
// module chunks = 0